<template>
	<div>
		<svg
			:width="size"
			:height="size"
			viewBox="0 0 18 20"
			:fill="color"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M15 1.5C15.8284 1.5 16.5 2.17157 16.5 3V16.5C16.5 17.3284 15.8284 18 15 18H9C8.17157 18 7.5 17.3284 7.5 16.5V12.75C7.5 12.3358 7.16421 12 6.75 12C6.33579 12 6 12.3358 6 12.75V16.5C6 18.1569 7.34315 19.5 9 19.5H15C16.6569 19.5 18 18.1569 18 16.5V3C18 1.34315 16.6569 -8.9407e-08 15 0L9 2.68221e-07C7.34315 3.12924e-07 6 1.34315 6 3V6.75C6 7.16422 6.33579 7.5 6.75 7.5C7.16421 7.5 7.5 7.16422 7.5 6.75V3C7.5 2.17157 8.17157 1.5 9 1.5L15 1.5ZM4.28033 6.21967C3.98744 5.92678 3.51256 5.92678 3.21967 6.21967L0.21967 9.21967C-0.0732232 9.51257 -0.0732232 9.98744 0.21967 10.2803L3.21967 13.2803C3.51256 13.5732 3.98744 13.5732 4.28033 13.2803C4.57322 12.9874 4.57322 12.5126 4.28033 12.2197L2.56066 10.5L13.5 10.5C13.9142 10.5 14.25 10.1642 14.25 9.75C14.25 9.33579 13.9142 9 13.5 9L2.56066 9L4.28033 7.28033C4.57322 6.98744 4.57322 6.51256 4.28033 6.21967Z"
				:fill="color"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgLogout',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
		isActive: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
